import { MARKETING_INDUSTRY_ROUTE_PATHS } from '@/lib/marketing-route-manifest';

export { MARKETING_INDUSTRY_ROUTE_PATHS };

export type MarketingIndustryVisual =
  | 'collection'
  | 'engineered'
  | 'object'
  | 'precision';

export const MARKETING_INDUSTRIES = [
  { slug: 'apparel', label: 'Apparel', visual: 'collection' },
  { slug: 'footwear', label: 'Footwear', visual: 'engineered' },
  {
    slug: 'bags-accessories',
    label: 'Bags & Accessories',
    visual: 'object',
  },
  { slug: 'eyewear', label: 'Eyewear', visual: 'precision' },
  {
    slug: 'jewelry-watches',
    label: 'Jewelry & Watches',
    visual: 'precision',
  },
  { slug: 'packaging', label: 'Packaging', visual: 'object' },
  { slug: 'furniture', label: 'Furniture', visual: 'object' },
  {
    slug: 'beauty-personal-care',
    label: 'Beauty & Personal Care',
    visual: 'collection',
  },
  { slug: 'toys', label: 'Toys', visual: 'collection' },
  { slug: 'sporting-goods', label: 'Sporting Goods', visual: 'engineered' },
] as const;

export type MarketingIndustry = (typeof MARKETING_INDUSTRIES)[number];
export type MarketingIndustrySlug = MarketingIndustry['slug'];

const INDUSTRY_BY_SLUG = new Map<string, MarketingIndustry>(
  MARKETING_INDUSTRIES.map((industry) => [industry.slug, industry])
);

export function marketingIndustryHref(slug: string): string {
  return `/${slug}`;
}

export function getMarketingIndustry(slug: string): MarketingIndustry | null {
  return INDUSTRY_BY_SLUG.get(slug) ?? null;
}

export function marketingIndustryLinks(
  industries: ReadonlyArray<MarketingIndustry>
): Array<{ label: string; href: string }> {
  return industries.map(({ label, slug }) => ({
    label,
    href: marketingIndustryHref(slug),
  }));
}
